import React, { PureComponent } from 'react'
import RestingRater             from '../utils/RestingRater'
import CategoryMarker           from './CategoryMarker'
import { animateCSS }           from '../../../utils/animateCSS'
import ComponentHasTranslations from '../../../utils/component_has_translations'
import { capitalize }           from 'inflected'

class RestingIndicator extends PureComponent {

  constructor(props) {
    super(props);

    this.rater = new RestingRater() 

    this.state = { 
      sex: this.rater.sex,
      age: this.rater.age,
      age_range: this.rater.age_range,
    }
  }

  catHeightLg   = 50
  catHeightSm   = 45

  icons = (key) => {
    const icon_map = {
      'f' : 'person-dress',
      'm' : 'person',
    }

    return <i className={`fa fa-${icon_map[key]}`}/>
  }
  
  componentDidMount() {
  }

  setSex = (sex) => {
    this.rater.sex = sex
    this.rater.update()
    this.setState( {sex}, this.animateCategories)
  }

  setAgeRange = (age_range) => {
    this.rater.age_range = age_range
    this.rater.update()
    this.setState( {age_range}, this.animateCategories)
  }

  animateCategories = () => animateCSS('.categories-with-marker', ['bounceInUp', 'fast'])

  catHeight = () => {
    return this.props.breakpoint == 'sm' ? this.catHeightSm : this.catHeightLg 
  }

  catStyles = (i) => (
    {
      backgroundColor: this.rater.colors[i],
      height: `${this.catHeight() - 1}px` //-1 for border
    }
  )
  
  categoryCell = (cat, i) => {
    const cat_class = (this.props.bpm == null || this.rater.catNum() === i) ? 'active' : 'inactive'
    const range = this.rater.sex_age_ranges.slice().reverse()[i] || [] // !! reverse is IN PLACE
    
    return (
      <div key={cat} className={`category-cell ${cat_class}`} style={this.catStyles(i)}>
        <div className='emoji'> {this.rater.emoji[i]} </div>
        <div className='sex-icon'>
          {range[0]}-{range[1]} 
          {' '}
          <span className='bpm'>BPM</span>
        </div>
        <div className='cat-img-cont'>
          { this.icons(this.rater.sex) }
        </div>
        <div className=''>
          {capitalize(this.tr(cat))}
        </div>
      </div>
    )
  }

  markerPosition = () => {
    const sex_age_ranges = this.rater.sex_age_ranges
    if(!this.ageDataAvailable()) return 0  

    let   pos            = 0
    const bpm            = this.props.bpm
    const sex_range_i    = this.rater.sexRangeI()
    const min            = sex_age_ranges[0][0]
    const max            = sex_age_ranges[sex_age_ranges.length-1][1]
    const h_total        = this.catHeight() * sex_age_ranges.length 

    if(bpm - min < 0) {
      pos = 0
    } else if (bpm - max > 0 ) {
      pos = h_total
    } else if ( sex_range_i > -1) {
      const h = this.catHeight()
      pos = (sex_range_i * h) + (h/2) // the middle of the cat
    } else {
      pos = 0
    }

    return pos
  }
  
  ageDataAvailable = () => this.rater.sex_age_ranges.length > 0

  sexControl = (sex) => {
    const on_off = sex === this.state.sex ? 'on' : 'off'

    return(
      <div className={`input-group-text sex-option ${on_off}` } onClick={() => this.setSex(sex)}>
        { this.icons(sex) }
      </div>
    )
  }

  render = () => {
    this.rater.bpm = this.props.bpm

    console.log( 'render')
    this.props.setRateIndicatorColor(this.rater.color())

    return (
      <div className='resting-rate-indicator'>
        <div className="inputs row row-cols-auto mb-3">
          <div>
            <div className="input-group">
              { this.sexControl('f') }
              { this.sexControl('m') }
            </div>
          </div>
          <div>
            {this.tr('age')}:
            {' '}
            <select
              className='form-control form-control-sm d-inline-block'
              style={{width: '60px'}}
              onChange={(e) => this.setAgeRange(e.target.value)} 
              value={this.state.age_range}
            >
              {
                this.rater.age_ranges.map(
                  range => <option value={range} key={range}>{range}</option>
                )
              }
            </select>
          </div>
        </div>
        <div className='categories-with-marker'>
          { this.rater.categories.map( 
              (cat, i) => this.categoryCell(cat, i)
            )
          }
          <CategoryMarker position={this.markerPosition()} />
        </div>
      
      </div>
    )
  }
}

Object.assign(RestingIndicator.prototype, ComponentHasTranslations)
export default RestingIndicator
